/*eslint-disable*/ export const messages = {
    "Go to the first page": "Vai alla pagina iniziale",
    "Go to the last page": "Vai alla pagina finale",
    "Pagination, showing {from} through {to} of {total} entities": [
        "Impaginazione, visualizzazione ",
        ["from"],
        " fino a ",
        ["to"],
        " di ",
        ["total"],
        " entità",
    ],
    "Show next {entitiesPerPage} entities": ["Visualizza successive ", ["entitiesPerPage"], " entità "],
    "Show previous {entitiesPerPage} entities": ["Visualizza precedenti ", ["entitiesPerPage"], " entità "],
    "{from} through {to} of {total}": [["from"], " fino a ", ["to"], " di ", ["total"]],
    "{from}-{to} of {total}": [["from"], "-", ["to"], " di ", ["total"]],
};
